export const SEASON_TIMEZONE = 'America/New_York';
export const SEASON_CUTOVER_MONTH = 4;
export const SEASON_CUTOVER_DAY = 30;

export const getCurrentSeason = (now: Date = new Date()): string => {
	const parts = new Intl.DateTimeFormat('en-US', {
		timeZone: SEASON_TIMEZONE,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).formatToParts(now);

	const year = Number(parts.find((p) => p.type === 'year')!.value);
	const month = Number(parts.find((p) => p.type === 'month')!.value);
	const day = Number(parts.find((p) => p.type === 'day')!.value);

	const cutoverPassed =
		month > SEASON_CUTOVER_MONTH ||
		(month === SEASON_CUTOVER_MONTH && day >= SEASON_CUTOVER_DAY);
	const start = cutoverPassed ? year : year - 1;

	return `${start}-${String(start + 1).slice(2)}`;
};
